/**
 * <products-tab-section> — sections/featured-collection.liquid
 *
 */
(function () {
  if (customElements.get("products-tab-section")) return;

  class ProductsTabSection extends HTMLElement {
    connectedCallback() {
      this.tablist = this.querySelector(".pts_tablist");
      this.tabs = Array.from(this.querySelectorAll(".pts_tab"));
      this.panels = Array.from(this.querySelectorAll(".pts_panel"));

      if (!this.tabs.length || !this.panels.length) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => this.activate(index, { focusTab: false }));
      });

      if (this.tablist) {
        this.tablist.addEventListener("keydown", (event) => this.onKeydown(event));
      }
    }

    onKeydown(event) {
      const currentIndex = this.tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      let nextIndex = null;

      switch (event.key) {
        case "ArrowRight":
          nextIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case "ArrowLeft":
          nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case "Home":
          nextIndex = 0;
          break;
        case "End":
          nextIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activate(nextIndex, { focusTab: true });
    }

    activate(index, { focusTab }) {
      const tab = this.tabs[index];
      const panel = this.panels[index];
      if (!tab || !panel) return;

      this.tabs.forEach((t, i) => {
        const isActive = i === index;
        t.classList.toggle("is-active", isActive);
        t.setAttribute("aria-selected", String(isActive));
        t.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((p, i) => {
        const isActive = i === index;
        p.classList.toggle("is-active", isActive);
        p.hidden = !isActive;
      });

      if (focusTab) tab.focus();

      this.refreshSwiper(panel);
    }

    refreshSwiper(panel) {
      const swiperEls = panel.querySelectorAll(".swiper");
      if (!swiperEls.length) return;

      requestAnimationFrame(() => {
        swiperEls.forEach((el) => {
          if (el.swiperInstance) el.swiperInstance.update();
          if (typeof equalizeProductCardHeights === "function") {
            equalizeProductCardHeights(el);
          }
        });
      });
    }
  }

  customElements.define("products-tab-section", ProductsTabSection);
})();
